import {HStack, SkeletonCircle, SkeletonText} from '@chakra-ui/react';
import type {GroupBase, LoadingIndicatorProps} from 'chakra-react-select';
import {chakraComponents} from 'chakra-react-select';
import React from 'react';

export const LoadingIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: LoadingIndicatorProps<Option, IsMulti, Group>,
) => {
  const {
    selectProps: {isInitialLoading},
    hasValue,
  } = props;
  if (isInitialLoading && !hasValue) {
    return (
      <HStack>
        <SkeletonCircle size={`32px`} />
        <SkeletonText noOfLines={1} minW={`10ch`} />
      </HStack>
    );
  }
  return <chakraComponents.LoadingIndicator spinnerSize={`sm`} thickness={`1px`} {...props} />;
};
